module.exports = __webpack_public_path__ + "media/landing-page/ups-bubble-49b04105.png";